// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__hYA5s","contentWrapper":"styles_contentWrapper__8oE0C","content":"styles_content__KEvbA"};